import React, { ChangeEvent, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CImage,
  CSpinner,
  CRow,
  CTabContent,
} from '@coreui/react-pro'
import {
  $updateAchievementDone,
  resetUpdateAchievementDone,
  setAchievement,
  submitUpdateAchievement,
} from './model'
import { useAchievementsEdit } from './hooks'
import { message, UploadProps } from 'antd'
import { useStore } from 'effector-react'
import { path } from '../../../../libs'

export const EditAchievement = () => {
  const { achievement, loading } = useAchievementsEdit()
  const updateAchievementDone = useStore($updateAchievementDone)
  const navigate = useNavigate()

  useEffect(() => {
    if (updateAchievementDone) {
      navigate(path.copytrade.achievements.entry())
      resetUpdateAchievementDone()
    }
  }, [updateAchievementDone, navigate])

  const props: UploadProps = {
    name: 'file',
    maxCount: 1,
    beforeUpload: (file) => {
      // @ts-ignore
      setAchievement({ ...achievement, file: file })
      return false
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message
          .success(`${info.file.name} file uploaded successfully`)
          .then((r) => console.log(r))
      } else if (info.file.status === 'error') {
        message
          .error(`${info.file.name} file upload failed.`)
          .then((r) => console.log(r))
      }
    },
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else if (event.currentTarget.type === 'file') {
      value = (event.currentTarget as HTMLInputElement).files![0]
    } else {
      value = event.currentTarget.value
    }

    setAchievement({
      ...achievement,
      [event.currentTarget.name]: value,
    })
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Edit achievements</strong>
        </CCardHeader>
        <CCardBody>
          <CTabContent className="pt-3">
            <CForm>
              {achievement.imagePath && (
                <CRow className="mb-3">
                  <CCol sm={4}>
                    <CImage
                      rounded
                      thumbnail
                      src={achievement.imagePath}
                      width={200}
                      height={200}
                    />
                  </CCol>
                </CRow>
              )}
              <CRow className="mb-3">
                <CCol sm={4}>
                  {`Name: ${achievement.name}`}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="file"
                    id="file"
                    name="file"
                    label="Choose image"
                    onChange={handleChange}
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="priority"
                    name="priority"
                    value={achievement.priority}
                    onChange={handleChange}
                    label="Priority"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="date"
                    id="enabledAt"
                    name="enabledAt"
                    value={achievement.enabledAt}
                    onChange={handleChange}
                    label="Enabled at"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormCheck
                    name="isDisabled"
                    checked={achievement.isDisabled}
                    onChange={handleChange}
                    label="Disabled"
                  />
                </CCol>
              </CRow>
              <CButton
                className="mb-3"
                onClick={() => {
                  submitUpdateAchievement(achievement)
                }}
              >
                Save
              </CButton>
            </CForm>
          </CTabContent>
        </CCardBody>
      </CCard>
    </div>
  )
}
